import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const IcecreamParlor = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => { 
        setWindowDimensions(); 
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []); 

    const features = [ 
        {
            id: 1,
            image: "/assets/outlet/iceCreamOutlet/posImage.webp",
            tag: "Point Of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Super Fast Billing",
            desc: "Experience awesomeness with the fastest checkouts as well as the multi-payment billing system by QueueBuster. Very conveniently process bulk transactions and create part or split payment bills. To enhanced performances, QueueBuster offers you:",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem", 
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Checkout speed less than 5 seconds
                </>,
                <>
                    Multi-batch payment processing
                </>,
                <>
                    Generation of a plethora of invoices like proforma, credit, sales, and e-Invoices.
                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/outlet/iceCreamOutlet/inventoryManagmentImage.webp",
            tag: "Inventory Management",
            icon: "/assets/outlet/iceCreamOutlet/inventoryManagementIcon.svg",
            title: "Stock-in & Stock-out Management",
            desc: "You wouldn't want to run out of ice cream. It is quite simple to monitor when more stock should be replenished with QueueBuster Inventory Management in place. Set minimum stock levels, and the system will notify you as and when it is required to build up stock again.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Easily set minimum stock levels so that stocks never run out in your favorite flavors.
                </>,
                <>
                    Manage barcodes, MRPs, expiry dates, and more for your items.
                </>,
                <>
                    Get alerts for restocking when the stock becomes low.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/outlet/iceCreamOutlet/vendorManagementImage.webp",
            tag: "Vendor Management",
            icon: "/assets/outlet/iceCreamOutlet/vendorIcon.svg",
            title: "Effortlessly Manage Multiple Vendors with QueueBuster",
            desc: "Do you have many vendors? Tired of keeping track of who owes you money, whom do you owe, and the list goes on? Now give your brain a break and let QueueBuster do all that heavy memory lifting. Along with this, you can send due reminders through email and SMS to the receivable parties.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>
                    Now, manage elaborate records of transactions with multiple vendors.
                </>,
                <>
                    Manage all receivables and payables easily through a comprehensive party management system.
                </>,
                <>
                    Send payment reminders automatically through email and SMS.
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/outlet/iceCreamOutlet/estoreImage.webp",
            tag: "eStore",
            icon: "/assets/outlet/iceCreamOutlet/estoreIcon.svg",
            title: "Sell Online, Sell Anytime",
            desc: "Sometimes, your customers may not feel like going out. You can, with the same ease, create your online eStore on QueueBuster quickly. Just open the QB App, click on eStore and get your online store link or QR code.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Easily set up an online store using the QueueBuster app.
                </>,
                <>
                    Add items with descriptions, images, and prices.
                </>,
                <>
                   Share with your customers through WhatsApp, email etc.
                </>,
            ],
        },
        {
            id: 5,
            image: "/assets/outlet/iceCreamOutlet/reportingImage.webp",
            tag: "Daily Sales Reporting",
            icon: "/assets/outlet/iceCreamOutlet/reportsIcon.svg",
            title: "Generate Daily, and Monthly Reports",
            desc: "It could be for a day's business, the entire month, or the whole financial year. You can easily generate reports while on the go, either from our mobile application or on the desktop version, about analyzing your financial health and hence making the right decisions to move forward.",
            tagColor: "#FFC3C3",
            bgColor: "#FFF3F3",
            stackColor1: "#FFF3F3",
            stackColor2: "#FFEBEB",
            stackColor3: "#FFDBDB",
            stackColor4: "#FFC3C3",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Comprehensive financial reports daily, monthly, or yearly.
                </>,
                <>
                    Get 80+ reports related to sales, purchases, and profit & loss.
                </>,
                <>
                    Have the basis for business decisions through real-time data.
                </>,
            ],
        },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What special thing is associated with QueueBuster Billing Software that is going to be used in ice cream parlors?
                </span>
            ),
            des: "This is ice cream parlor software that pulls all the strings to feature everything in the business. This particular package features complete inventory management, so you don't come up short on that special flavor again, vendor management for all your different vendors or suppliers in inventory, an eStore feature for online ordering, and robust reporting tools so as to track sales trends. All these come together to reduce the hassle of running the day-to-day operations and ensure that you give your customers the service they need in order to drive the growth of your business.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does this feature of inventory management help in preventing stockouts?
                </span>
            ),
            des: "One can set the number of items at the minimum level for reordering. Automatically get alerts to refill once the stock levels reach below your set thresholds. Track items by their barcodes, MRP, expiry dates, or other attributes to ensure the continuance of popular flavors and no customers leave disappointed.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster handle multiple vendors, and how does it simplify vendor management?
                </span>
            ),
            des: "Yes. QueueBuster keeps detailed records of all your transactions with different vendors. So, it does simplify your task of tracking the receivables and payables automatically, including sending payment reminders through email/SMS. This helps in avoiding excess manual intervention in situations of regular order requisitions and ensuring that your payments to vendors and collections from customers are always on time.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How do I set up an online store for my ice cream parlor through QueueBuster?
                </span>
            ),
            des: "Online shop setup is quite easy. One needs to open the app and click on 'My Online Store' from the menu, add stuff from their inventory, add detailed descriptions, and images, add its price, and publish it. One can share the link of the store with customers over WhatsApp, SMS, e-mail, or any such channel for them to order as they lie on their couches.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What are the different types of reports that can be obtained with this software?
                </span>
            ),
            des: "You can create a host of reports to analyze your financial health status: sales reports, purchase reports, day books, profit and loss statements, balance sheets, cash flow statements, party statements, GST reports, tax reports, and expense reports. These reports help you make effective business decisions and monitor the performance of your parlor.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Will the software support billing through thermal and laser printers?
                </span>
            ),
            des: "This software does support both thermal and laser printers. You should, therefore, not encounter any problems when printing physical copies of bills and invoices. Sharing through email and WhatsApp is also accommodated to provide flexibility and convenience in your billing processes.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How would this feature of eStore help me, as an ice cream parlor owner, help my business during off-peak seasons as well?
                </span>
            ),
            des: "The eStore feature will enable customers to place orders online, which is most helpful during off-peak periods or low walk-in volumes. Offer your customers a simple online ordering facility so customers can continue buying from you and carry on your business without any hindrances, even when the number of footfalls is declining.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What are the payment options in QueueBuster?
                </span>
            ),
            des: "The software features various payment modes such as cash, credit/debit card, digital wallet, and UPI. The software offers inbuilt flexibility in terms of the different choices and can be accommodating to the different preferences of customers. It quickens transactions and this can result in better customer experiences.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster ensure data security and privacy?
                </span>
            ),
            des: "This makes it good in terms of safety features, as it encrypts data and ensures frequent backups. It still has some sort of access control, while all the sensitive information is accessed by authorized personnel only. All this ensures that your business data remains secured and confidential.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Will QueueBuster be able to integrate with other business management tools that I use?
                </span>
            ),
            des: "Yes, it can integrate with several business management tools. This allows assurance of sharing data between them, further ensuring that your operations will be streamlined. From accounting software to CRM systems, and other POS devices, it becomes integrated to ensure smooth management of all the activities associated with the business.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/iceCreamOutlet/iceCreamMobile.webp')" }}>
                        <div>
                            <h1>
                                <span> Billing Software for</span>
                                <span>&nbsp; Ice Cream Parlors</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Unlock your ice cream parlor's business potential with QB Billing Software. Sequence your billing processes, manage inventory efficiently, and get actionable insights into your sales trend. Deliver a great experience to your customers: quicker transactions and accurate bills.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/caseStudy/iceCreamParlourImage.webp"
                            heading={<>Billing Software for </>} 
                            staticHeading={<>Ice Cream Parlors</>}
                            description={"Unlock your ice cream parlor's business potential with QB Billing Software. Sequence your billing processes, manage inventory efficiently, and get actionable insights into your sales trend. Deliver a great experience to your customers: quicker transactions and accurate bills."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "55%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Best Features of Billing Software for Ice Cream Parlors</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"Frequently Asked Questions for Ice-Cream Parlor POS Software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"Frequently Asked Questions for Ice-Cream Parlor POS Software"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default IcecreamParlor